export const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

export const versionComparator = (a, b, orderBy) => {
  const versionA = (a[orderBy] + ".0.0").split(".").slice(0, 3).map(Number);
  const versionB = (b[orderBy] + ".0.0").split(".").slice(0, 3).map(Number);

  for (let i = 0; i < versionA.length; i++) {
    if (isNaN(versionA[i]) || isNaN(versionB[i])) {
      return 1;
    }

    if (versionA[i] !== versionB[i]) {
      return orderBy === "asc"
        ? versionA[i] - versionB[i]
        : versionB[i] - versionA[i];
    }
  }

  return 0;
};

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const getComparator = (order, orderBy) => {
  if (orderBy === "software_version") {
    return order === "desc"
      ? (a, b) => versionComparator(a, b, orderBy)
      : (a, b) => -versionComparator(a, b, orderBy);
  }
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};
